import React from 'react';
import { ArrowRightIcon, CalendarIcon, FileTextIcon, LayersIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionBadge } from '../SectionBadge';
import { HERO_FEATURES, HERO_MOCKUP } from '../../data/content';
const FEATURE_ICONS = [FileTextIcon, ZapIcon, LayersIcon, CalendarIcon];

/**
 * Above-the-fold content renders immediately (no scroll animation) so the
 * headline, mockup and CTA paint as fast as possible.
 */
export function Hero({
  onCta
}: {
  onCta: () => void;
}) {
  return <section className="relative w-full px-5 pb-12 pt-10 sm:pb-16 sm:pt-14" data-id="element-136" data-mp="qtszj7lz6623">
      <div className="relative mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-137" data-mp="vnnfq12dg2wf">
        <SectionBadge data-id="element-138" data-mp="10kdtuium8of7">Para profesoras de Danza Árabe</SectionBadge>

        <h1 className="mt-5 font-display text-[36px] leading-[1.05] text-snow sm:text-5xl lg:text-6xl" data-id="element-139" data-mp="15ks487jowage">
          <span className="block" data-id="element-140" data-mp="1ajd425v14s4b">
            Resolvé todo tu <em className="italic text-lime" data-id="element-141" data-mp="1ajuyqy21mya4">año de Danza Árabe</em>
          </span>
          <span className="mt-1 block" data-id="element-142" data-mp="9olwy78xtumb">
            en <span className="text-gold" data-id="element-143" data-mp="4optc945k57a">5 minutos</span>
          </span>
        </h1>

        <div className="mt-6 w-full" data-id="element-144" data-mp="4qsu9o6ufiqs">
          <img src={HERO_MOCKUP} alt="MegaPack Árabe PRO: tomos anillados, tablet, computadora y celular con el material" width={1456} height={1092} sizes="(min-width: 768px) 672px, calc(100vw - 40px)" loading="eager" fetchPriority="high" className="mx-auto aspect-[4/3] w-full max-w-2xl object-contain mix-blend-multiply" data-id="element-145" data-mp="3vuhhx42a79rz" />
        </div>

        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-snow sm:text-base" data-id="element-146" data-mp="nfr1nnr5xd3i">
          <span className="block" data-id="element-147" data-mp="imxxb0zlw6ry">
            <strong className="font-bold" data-id="element-148" data-mp="im4q5ywqjf9a">6 contenidos completos</strong> y{' '}
            <strong className="font-bold" data-id="element-149" data-mp="emnj511nua20">5 bonos exclusivos</strong> para planificar, enseñar y{' '}
            <span className="u-lime font-semibold" data-id="element-150" data-mp="1b6wh41t6y3da">renovar tus clases</span> durante todo el año.
          </span>
          <span className="mt-1 block text-snow-muted" data-id="element-151" data-mp="16c8obqr5mmsw">Sin seguir perdiendo horas pensando qué enseñar mañana.</span>
        </p>

        <div className="mt-7 w-full" data-id="element-152" data-mp="35ljq2h741n4g">
          <CtaButton variant="lime" className="w-full max-w-sm" onClick={onCta} data-id="element-153" data-mp="35kh3glgtm6uc">
            Quiero mi MegaPack Árabe PRO <ArrowRightIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-154" data-mp="2qvudzqxhbype" />
          </CtaButton>
          <p className="mt-2.5 text-xs font-semibold text-snow-muted" data-id="element-155" data-mp="2vt4atrn77cn9">
            Acceso inmediato · Pago único · <span className="text-snow" data-id="element-156" data-mp="2hxiq3wnzzf0n">Garantía de 7 días</span>
          </p>
        </div>

        <div className="mt-7 w-full" data-id="element-157" data-mp="2msfv8si5p489">
          <div className="mx-auto flex max-w-xl flex-wrap items-center justify-center gap-x-6 gap-y-2.5" data-id="element-158" data-mp="27xrt9obysnxe">
            {HERO_FEATURES.map((label, index) => {
            const Icon = FEATURE_ICONS[index % FEATURE_ICONS.length];
            return <span key={label} className="inline-flex items-center gap-2 text-sm font-bold text-snow" data-id="element-159" data-mp="676lwfn5mnu9" data-mpi={index}>
                  <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-160" data-mp="b4g9rquwarfz" />
                  {label}
                </span>;
          })}
          </div>
        </div>

        <div className="mt-6 inline-flex items-center gap-3 rounded-full border border-ink-line bg-ink px-5 py-2.5" data-id="element-161" data-mp="1qofq3soij78y">
          <span className="flex gap-0.5" aria-label="Calificación 4.9 de 5" data-id="element-162" data-mp="25dvex34hh2m0">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-163" data-mp="20kagj9yza6ma" data-mpi={index} />)}
          </span>
          <span className="text-xs font-bold text-snow" data-id="element-164" data-mp="2ac6r3ki93p7e">
            4.9/5 · <span className="text-lime" data-id="element-165" data-mp="2abn59sphcgo3">+500 profesoras</span>
          </span>
        </div>
      </div>
    </section>;
}